import { Link } from "react-router-dom";
import { useConsent } from "../context/ConsentContext";

// Social Media Icons with brand colors
const socialLinks = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/share/18mPDmp2bs/?mibextid=wwXIfr",
    color: "bg-[#E8F4FC] hover:bg-[#D8EBF8]",
    iconColor: "text-[#35759B]",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    )
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/everydayworkstoday",
    color: "bg-[#FCE8EC] hover:bg-[#F8D8E0]",
    iconColor: "text-[#B84E64]",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    )
  },
  {
    name: "Pinterest",
    href: "https://pin.it/1EjCRt9DM",
    color: "bg-[#FCE8EC] hover:bg-[#F8D8E0]",
    iconColor: "text-[#A84A7D]",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
      </svg>
    )
  },
  {
    name: "YouTube",
    href: "https://youtube.com/@everydayworkstoday?si=KPBATQ3JuIRjBCNF",
    color: "bg-[#FCE8EC] hover:bg-[#F8D8E0]",
    iconColor: "text-[#B04E2E]",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    )
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/t/ZP8GUAfUh/",
    color: "bg-[#F0E8FC] hover:bg-[#E8DCF8]",
    iconColor: "text-[#7A57B0]",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
      </svg>
    )
  },
  {
    name: "Twitter",
    href: "https://x.com/sadiegordo06?s=21",
    color: "bg-[#E8F4FC] hover:bg-[#D8EBF8]",
    iconColor: "text-[#35759B]",
    icon: (
      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    )
  }
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { openSettings } = useConsent();
  
  const legalLinks = [
    { path: "/privacy", label: "Privacy Policy" },
    { path: "/terms", label: "Terms of Service" },
    { path: "/refund-policy", label: "Digital Product License and Refund Policy" },
    { path: "/disclaimer", label: "Disclaimer" },
    { path: "/consumer-health-data", label: "Consumer Health Data Privacy Notice" },
    { path: "/ai-disclosure", label: "AI Use and AI-Assisted Content Disclosure" },
    { path: "/affiliate-disclosure", label: "Affiliate Disclosure" },
    { path: "/delete-app", label: "Delete App Data" },
    { path: "/cookies", label: "Cookie Policy" },
  ];

  return (
    <footer className="bg-[#2D2D3A] text-white" data-testid="main-footer">
      {/* Main footer content */}
      <div className="py-12 px-6 md:px-12 lg:px-16 border-b border-[#3D3D4A]">
        <div className="max-w-5xl mx-auto">
          {/* Tagline */}
          <p className="text-center text-[#B8B8C4] text-sm mb-8 max-w-md mx-auto">
            Practical tools designed for real life. Stay organized without relying on memory.
          </p>

          {/* Social Media Buttons - 3 on top, 3 on bottom */}
          <div className="flex flex-col items-center gap-4 mb-8" data-testid="social-links">
            {/* First row - 3 buttons */}
            <div className="flex items-center justify-center gap-3">
              {socialLinks.slice(0, 3).map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 rounded-full ${social.color} ${social.iconColor} flex items-center justify-center transition-all duration-200 hover:scale-110`}
                  aria-label={social.name}
                  data-testid={`social-${social.name.toLowerCase()}`}
                >
                  {social.icon}
                </a>
              ))}
            </div>
            {/* Second row - 3 buttons */}
            <div className="flex items-center justify-center gap-3">
              {socialLinks.slice(3, 6).map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 rounded-full ${social.color} ${social.iconColor} flex items-center justify-center transition-all duration-200 hover:scale-110`}
                  aria-label={social.name}
                  data-testid={`social-${social.name.toLowerCase()}`}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
          
          {/* Legal Links */}
          <nav className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {legalLinks.map((link) => (
              <Link 
                key={link.path}
                to={link.path}
                className="text-sm text-[#B8B8C4] hover:text-white transition-colors"
                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </Link>
            ))}
            <button
              type="button"
              onClick={openSettings}
              className="text-sm text-[#B8B8C4] hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-white rounded"
              data-testid="footer-cookie-settings"
            >
              Cookie Settings
            </button>
          </nav>
        </div>
      </div>
      
      {/* Copyright bar */}
      <div className="py-4 px-6 md:px-12 lg:px-16">
        <p className="text-xs text-[#ADADBA] text-center">
          © {currentYear} Everyday Works. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
